

import PPromise from 'p-progress';
import api from '../api';
import patch from '../patch';
import { IWorkspaceDB } from '../../interface/db';
import load from "../db/update";
import { IPatchStorage } from "../patch/interface";
import { IUpdateSiteConfig } from "./updatesite.if";
import { IFetcher, IZip } from "../../interface/util";
import { IAuthenticationManager } from '../../interface/authentication';
import { IConfigAPI, injectConfigAPI } from '../../interface/config';


function update(fetcher: Promise<IFetcher>, zipper: Promise<IZip>, db: IWorkspaceDB, auth: IAuthenticationManager, name: string): PPromise<void> {
    const configAPI = injectConfigAPI();

    return new PPromise(async function(resolve, reject, progress) {
        try {
            const zip = await zipper;
            await db.open();

            progress(0.1);

            const token = await auth.renew();

            progress(0.2);
    
            let existingPatch: IPatchStorage|null = null;

            try {
                existingPatch = await patch.storage.load(name);
            } catch (error)  {

            }

            progress(0.3);

            if ( !existingPatch ) {
                existingPatch = {
                    name: name,
                    hash: "",
                    data: {},
                };
            }
   
            const siteFetcher = api.siteData(configAPI.url, configAPI.extension.siteData, token, existingPatch.hash);

            siteFetcher.onProgress(function(data) {
                progress(0.3 + (data * 0.3));
            });

            progress(0.6);
            
            const siteResponse = await siteFetcher;

            /* only bother if there is something in the patch */
            if ( siteResponse.patch.length > 0 ) {
                let newPatch: IPatchStorage = {...existingPatch};
                newPatch.data = await patch.apply(siteResponse.patch, existingPatch.data);
                newPatch.hash = siteResponse.currentHash;
        
                await patch.storage.save(newPatch);
        
                await load(db, newPatch.data);
            }

            progress(0.8);
    
            db.close();

            resolve();
        } catch (error) {
            reject(error);
        }
    })
}

export default update;